import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataState } from '@shared/enums/DataState';
import { AsyncData } from '@shared/interfaces/asyncData';

import { SignInActivitiesPageData, State } from './types';

const initialState: State = {
  signInActivities: { data: null, state: DataState.Idle },
  total: 0,
  cache: {},
};

export const slice = createSlice({
  name: 'signInActivities',
  initialState,
  reducers: {
    setSignInActivitiesData(state, action: PayloadAction<Partial<AsyncData<SignInActivitiesPageData>>>) {
      state.signInActivities = { ...state.signInActivities, ...action.payload };
      if (!state.total) {
        state.total = action.payload.data?.total || 0;
      }
    },
    setCacheValue(state, action: PayloadAction<{ key: string; value: SignInActivitiesPageData }>) {
      state.cache[action.payload.key] = action.payload.value;
    },
  },
});

export const { setSignInActivitiesData, setCacheValue } = slice.actions;

export default slice.reducer;
